import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { BusTrackerImportComponent } from "../bus-tracker-import/bus-tracker-import.component";
import { DataService_BusTrackerBusMaintenance } from "../shared/data.service";
import { BusModifyComponent } from "./bus-modify/bus-modify.component";
import { BTGenericImportExportRequest } from "../shared/BTGenericImportExportRequest";
import * as moment from "moment";

@Component({
	selector: "caass-bus-maintenance-bus-table",
	templateUrl: "./bus-maintenance-bus-table.component.html",
	styleUrls: ["./bus-maintenance-bus-table.component.css"],
})
export class BusMaintenanceBusTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private BusService: DataService_BusTrackerBusMaintenance,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadBus();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() SelectedBusChanged: EventEmitter<any> = new EventEmitter();

	Processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBus: any;
	lstBus: any = [];

	//Filter listsF
	lstActiveDesc: any = [];
	lstDefinedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'BusNbr', header: 'Number' },
		// { field: 'BusDesc', header: 'Description' },
		{ field: "RouteCount", header: "Total Routes" },
		{ field: "StudentCount", header: "Total Students" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadBus() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.BusService.BusMaintenanceTableSelectList();
		result.subscribe(
			(response) => {
				this.lstBus = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstBus.map((item: any) => item.ActiveDesc))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstBus.map((item: any) => item.DefinedByDesc))).sort();

				this.onRowUnselect(null);

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBus();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(BusModifyComponent, {
			header: "Add Bus",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				Imported: false,
				EditMode: false,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBus();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		// if(this.CanEdit() == false){
		//   return;
		// }

		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a bus to edit";
			return;
		}

		var ref = this.dialogService.open(BusModifyComponent, {
			header: "Edit Bus",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				EditMode: true,
				Imported: this.SelectedBus.DefinedByID <= 2 ? true : false,
				BusID: this.SelectedBus.BusID,
				BusNbr: this.SelectedBus.BusNbr,
				BusDesc: this.SelectedBus.BusDesc,
				DefinedByID: this.SelectedBus.DefinedByID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBus();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a bus to toggle";
			return;
		}

		//Call SP
		this.Processing = true;

		var changeTo = this.SelectedBus.Active == true ? 0 : 1;

		var result = this.BusService.BusToggle(this.SelectedBus.BusID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadBus();
				} else {
					var MSG = "";

					if (changeTo == 1) {
						MSG = "Could not activate the bus";
					} else {
						MSG = "Could not deactivate the bus";
					}

					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "bus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedBus == undefined) {
			this.errorMessage = "Select a bus to delete";
			return;
		}

		//
		// Check if the alert type is in use
		//
		this.BusInUse();
	}

	BusInUse() {
		this.Processing = true;

		var result = this.BusService.BusInUse(this.SelectedBus.BusID);
		result.subscribe(
			(response) => {
				if (response) {
					this.confirmationService.confirm({
						key: "bus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Bus already in use. Delete routes assigned to this bus before deleting it.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					this.ConfirmDelete();
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	ConfirmDelete() {
		this.confirmationService.confirm({
			key: "confirmbusdelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this bus?",
			header: "Confirm Delete Bus",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				this.Processing = false;
			},
		});
	}

	FinishDelete() {
		var result = this.BusService.BusDelete(this.SelectedBus.BusID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadBus();
				} else {
					this.confirmationService.confirm({
						key: "bus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the Bus.",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(BusTrackerImportComponent, {
			header: "Import Data",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadBus();
			}
		});
	}

	onExport() {
		this.errorMessage = "";

		this.Processing = true;

		var nbrFilter = <HTMLInputElement>document.getElementById("Bus_BusNbrFilter").children[0].children[0].children[0];
		var nbrFilterValue = nbrFilter.value;

		var descFilter = <HTMLInputElement>document.getElementById("Bus_BusDescFilter").children[0].children[0].children[0];
		var descFilterValue = descFilter.value;

		var definedByDescFilter = <HTMLElement>document.getElementById("Bus_DefinedByDescFilter").children[0].children[0].children[0];
		var definedByDescValue = "";
		if (definedByDescFilter.innerText != "Any") {
			definedByDescValue = definedByDescFilter.innerText;
		}

		var activeDescFilter = <HTMLElement>document.getElementById("Bus_ActiveDescFilter").children[0].children[0].children[0];
		var activeDescValue = "";
		if (activeDescFilter.innerText != "Any") {
			activeDescValue = activeDescFilter.innerText;
		}

		var parms: BTGenericImportExportRequest = {
			BusNbr: nbrFilterValue,
			BusDesc: descFilterValue,
			DefinedByDesc: definedByDescValue,
			ActiveDesc: activeDescValue,
		};

		var result = this.BusService.ExportBusTrackerData(parms);
		result.subscribe(
			(response) => {
				var Data: any = response;

				var str: any = "";

				for (var z = 0; z < Data.length; z++) {
					var next = Data[z];

					str += next.StudentID + "\t";
					str += next.BusNbr + "\t";
					str += next.BusDesc + "\t";
					str += next.BusRouteTypeNbr + "\t";
					str += next.BusRouteTypeDesc + "\t";
					str += next.BusRouteNbr + "\t";
					str += next.BusRouteDesc;
					str += "\n";
				}

				// console.log(str);

				var blob = new Blob([str], { type: "text" });
				var url = window.URL.createObjectURL(blob);

				var a = document.createElement("a");
				a.href = url;

				a.download = "BusTrackerExport_" + moment(new Date()).format("MM_DD_YYYY") + ".txt";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBus = val.data;

		this.SelectedBusChanged.emit(this.SelectedBus);
	}
	onRowUnselect(val) {
		this.SelectedBus = null;

		this.SelectedBusChanged.emit(this.SelectedBus);
	}
	onRowDblClick(Bus) {
		this.SelectedBus = Bus;
		this.SelectedBusChanged.emit(this.SelectedBus);
		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CanEdit() {
		return this.SelectedBus == undefined ? false : true;
	}

	CanDelete() {
		if (this.SelectedBus == undefined) {
			return false;
		}
		if (this.SelectedBus.DefinedByID <= 2) {
			return false;
		}

		return true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
